export default __webpack_public_path__ + "static/media/32.41d4ab9e.png";